export default {
  actions: [],
  notCommittedActions: [],
  notCommittedActionsMeta: {},
  multiDetach: {
    nGram: '',
    data: {},
    index: 0,
    items: []
  }
};